import React from 'react';
import Header from '../components/DRHeader';
import { confirmBorderColor, confirmColor, moxiVerdigris } from '../constants/Styles';
import { ATTEMPT_NUMBERS } from '../constants/common';

import ArrivalScreen from './ArrivalScreen';
import ThinkingScreen from './ThinkingScreen';
import { elasticLogEvent, elasticLogError } from '../vodjs/ElasticLog';
import StoragePlusLoadingView from '../components/StoragePlusLoadingView';
import { DRButton } from '../components/DRControls';
import PinCodeEntryScreen from './PinCodeEntryScreen';
import ForgotPinCodeScreen from './ForgotPinCodeScreen';

// components utils
import Loader from '../components/Loader';
import { getRobotId, r2h } from '../vodjs/lib';
import {
  composeArrivalUnloadText,
  joinCommaSeparatedNames,
  GENERAL_DROPOFF_TEXT,
  LOST_CONNECTION_TEXT,
} from './utils/composeText';
import { BatchTypes } from './utils/taskAttrs';
import { TaskStepInteractView } from '../vodjs/TaskStepView';
import Locktube, { LOCKTUBE } from '../vodjs/Locktube';
import { updateTaskData } from '../vodjs/Task';
import { initializePinCode } from '../utils/commonUtils';
import { setAdminOverride, validatePinCode, adminOpenDrawers } from '../vodjs/PollMgr';

export default class UnloadScreen extends TaskStepInteractView {
  constructor(props) {
    super(props);

    let doBatchAssist = false;
    if (this.props.batchAssist && this.props.taskAttrs.batchData) {
      let { type, index, total } = this.props.taskAttrs.batchData;
      doBatchAssist = type === BatchTypes.manyToOne && index < total - 1;
    }
    if (this.props.taskAttrs.batchData) {
      let { type, index, total } = this.props.taskAttrs.batchData;
      if (type === BatchTypes.manyToOne && index < total - 1) {
        this.drawerMagic = true;
      }
    }

    let ccTaskInfo;
    let curTask = this.props.tasks.find((t) => t.uuid == this.props.taskAttrs.uuid);
    if(curTask?.task_data.ccTask) {
      ccTaskInfo = {
        mode:curTask.task_data.ccTask
      };
    }


    this.state = {
      recipientNote: '',
      isLoading: false,
      showSuccess: false,
      tubesUnloaded: false,
      locktubes: undefined,
      numDrawersUnlocked: 0,
      arrivalDismissed: false,
      arrivalMode: 0, // 0 = waiting for signal to show Continue button, 1 = showing Continue button, 2 = Loading
      anyTubeUnlocked: false,
      remainingCountdownTicks: undefined,
      doBatchAssist,
      scanResult: '',
      lastScanTimestamp: '',
      showPinCodeEntry: false,
      showForgotPinCode: false,
      forgotPinCodeClicked: false,
      code: '',
      codeInputError: '',
      tasksToUnload: [],
      unloadIdx: 0,
      lastUnloaded: '',
      currentOverrideStep: 0,
      overrideOption: '',
      overrideReason: '',
      overrideRecipient: '',
      showArrivalScreen: false,
      currentOverrideTask: '',
      ccTaskInfo
    };

    this.timerCanBeStarted = false;
    this.robotId = getRobotId(); //this.props.task.claimed_by
    this.handleLocktubeChange = this.handleLocktubeChange.bind(this);
  }

  componentWillUnmount() {
    if (this.rmvLocktubeListener) {
      this.rmvLocktubeListener();
      this.rmvLocktubeListener = undefined;
    }

    this.killCountdownTimer();
  }

  async componentDidMount() {
    elasticLogEvent({ what: 'unloadScreenShown', taskUuid: this.props.taskAttrs.uuid });

    let ccMode = this.state.ccTaskInfo?.mode;
    if (!this.props.taskAttrs.test && !this.state.doBatchAssist && ccMode != 'load') this.props.chime();

    if (this.robotId && !this.rmvLocktubeListener) {
      this.rmvLocktubeListener = Locktube.onUpdate(this.robotId, this.handleLocktubeChange);
    }
  }

  async handleLocktubeChange(locktubes) {
    const { autoPrioConfig, taskAttrs, tasks } = this.props;
    let state = {
      locktubes,
      tubesUnloaded: locktubes.status === LOCKTUBE.unloaded || locktubes.status === LOCKTUBE.unloading,
    };

    let anyTubeUnlocked = locktubes.anyTubeUnlocked();
    this.setState({ scanResult: locktubes.scanResult, lastScanTimestamp: locktubes.lastScanTimestamp });

    if (autoPrioConfig?.pin_code_phase1 && taskAttrs.codeRequired) {
      let tasksToUnload = this.state.tasksToUnload;

      if (!this.state.showForgotPinCode) {
        // Only update tasksToUnload if not in admin override
        tasksToUnload = [];

        if (taskAttrs.batchData?.type === 'M_1') {
          const batchId = taskAttrs.batchData.id;
          const batchTasks = tasks.filter((t) => t.task_data.batch?.id === batchId);

          if (batchTasks) {
            batchTasks.forEach((t) => {
              const unloadState = state.locktubes.taskAppState[t.uuid]?.unload_state;

              if (unloadState !== 'authenticated' && !tasksToUnload.includes(t.uuid)) {
                tasksToUnload.push(t.uuid);
              }
            });
          }
        }
        else {
          // When the ROC has to recreate a task to unload a robot, unload_state may be none
          const unloadState = state.locktubes.taskAppState[taskAttrs.uuid]?.unload_state;
          if (unloadState !== 'authenticated' && !tasksToUnload.includes(taskAttrs.uuid)) {
            tasksToUnload.push(taskAttrs.uuid);
          }
        }
      }

      this.setState({ code: initializePinCode(4), tasksToUnload });
      if (tasksToUnload.length && locktubes.taskAppState[tasksToUnload[this.state.unloadIdx]]) {
        if (locktubes.taskAppState[tasksToUnload[this.state.unloadIdx]].unload_state === 'wait_for_scan') {
          this.setState({ showArrivalScreen: true });
        }
        else if (locktubes.taskAppState[tasksToUnload[this.state.unloadIdx]].unload_state === 'wait_for_pin') {
          this.setState({
            showPinCodeEntry: true,
            showForgotPinCode: false,
            forgotPinCodeClicked: false,
            currentOverrideStep: 0,
            showArrivalScreen: false,
          });
        }
        else if (locktubes.taskAppState[tasksToUnload[this.state.unloadIdx]].unload_state === 'wait_for_admin_scan') {
          this.setState({
            showPinCodeEntry: false,
            showForgotPinCode: true,
            codeInputError: '',
            showArrivalScreen: false,
            currentOverrideTask: tasksToUnload[this.state.unloadIdx],
          });
        }
        else if (locktubes.taskAppState[tasksToUnload[this.state.unloadIdx]].unload_state === 'wait_for_admin_pin') {
          this.setState({
            showPinCodeEntry: false,
            showForgotPinCode: true,
            currentOverrideStep: 2,
            showArrivalScreen: false,
            currentOverrideTask: tasksToUnload[this.state.unloadIdx],
          });
        }
      }
    }

    let numDrawersUnlocked = 0;
    let unlockedDrawerNames = [];
    ['small', 'medium', 'large'].forEach((container) => {
      if (locktubes.tubes[container].unlocked) {
        ++numDrawersUnlocked;
        unlockedDrawerNames.push(container);
      }
    });

    if (anyTubeUnlocked) {
      this.killCountdownTimer(state);
      this.timerCanBeStarted = true;

      if (autoPrioConfig?.pin_code_phase1 && taskAttrs.codeRequired) {
        if (this.props.taskAttrs.batchData && this.props.taskAttrs.batchData.type === BatchTypes.manyToOne) {
          const updatedTasksToUnload = this.state.tasksToUnload.filter(
            (t) => t.uuid !== this.state.tasksToUnload[this.state.unloadIdx],
          );

          if (updatedTasksToUnload.length) this.setState({ tasksToUnload: updatedTasksToUnload, unloadIdx: 0 });
        }
        this.setState({ showPinCodeEntry: false, showForgotPinCode: false });
      }
    }

    state.anyTubeUnlocked = anyTubeUnlocked;
    state.numDrawersUnlocked = numDrawersUnlocked;

    if (locktubes.status === 'ready_to_unload' || locktubes.status === 'unloading') {

      let ccMode = this.state.ccTaskInfo?.mode;

      if (this.drawerMagic || ccMode == 'load') {
        try {
          await Locktube.updateLocktubeStatus(this.robotId, LOCKTUBE.unloaded);

          let msg = `drawerMagic: skipped unload for ${taskAttrs.uuid}${ccMode == 'load' ? ' for cc load task' : ''}.`

          elasticLogEvent({
            what: 'skipUnload',
            taskId: taskAttrs.uuid,
            msg
          });
        }
        catch (err) {
          elasticLogError({
            what: 'skipUnloadFail',
            taskId: taskAttrs.uuid,
            msg: `drawerMagic: problem skipping unload: ` + err,
          });
        }
        return;
      }
    }

    let dbInfo = '-----';
    state.arrivalMode = 1;
    if (locktubes.status === 'unloading' && !this.state.showArrivalScreen) {
      //rather than 'ready_to_unload'
      state.arrivalDismissed = true;
      if (state.arrivalMode !== 2) dbInfo = 'arrv=>2+';
      state.arrivalMode = 2; //latch
    }
    else {
      if (locktubes.arrivalReadyForContinue && this.state.arrivalMode === 0) {
        if (state.arrivalMode !== 1) dbInfo = 'arrv=>1';
        state.arrivalMode = 1;
      }
      if (state.arrivalDismissed === taskAttrs.uuid) {
        if (state.arrivalMode !== 2) dbInfo = 'arrv=>2';
        state.arrivalMode = 2;
      }
    }
    let arrivalDismissed = state.arrivalDismissed || this.state.arrivalDismissed;

    if (arrivalDismissed && state.arrivalMode === 2 && !anyTubeUnlocked && this.timerCanBeStarted) {
      this.timerCanBeStarted = false;

      //start the visual countdown timer
      this.startingCountdownTicks = 1000 * 7; //TODO: get from lockproxy
      state.remainingCountdownTicks = this.startingCountdownTicks;
      state.coundownEndTicks = Date.now() + state.remainingCountdownTicks;

      let decrement = () => {
        this.rolloutCountdownTimer = undefined;
        let remainingCountdownTicks = Math.max(0, this.state.coundownEndTicks - Date.now());
        if (remainingCountdownTicks > 0) this.rolloutCountdownTimer = setTimeout(decrement, 250);
        this.setState({ remainingCountdownTicks });
      };

      this.rolloutCountdownTimer = setTimeout(decrement, 250);
    }

    elasticLogEvent({
      what: 'unloadTubeCB',
      cont: !!locktubes.arrivalReadyForContinue,
      dism: arrivalDismissed,
      mode1: this.state.arrivalMode,
      mode2: state.arrivalMode,
      dbInfo,
      numDrawersUnlocked,
    });

    this.setState(state);
  }

  killCountdownTimer(state) {
    if (this.rolloutCountdownTimer) {
      clearTimeout(this.rolloutCountdownTimer);
      this.rolloutCountdownTimer = undefined;
    }
    if (state) state.remainingCountdownTicks = undefined;
    else this.setState({ remainingCountdownTicks: undefined });
  }

  async cancelRollout() {
    this.killCountdownTimer();
    this.setState({ arrivalDismissed: false, arrivalMode: 1 });

    await Locktube.cancelRollout(this.robotId).catch((error) => {
      elasticLogError({
        what: 'cancelROlloutFail',
        taskId: this.props.taskAttrs?.uuid,
        msg: `cancelRollout: error from Locktube.cancelRollout: ` + error,
      });
    });
  }

  getPickupDisplayNames = (arrival) => {
    const { taskAttrs, tasks } = this.props;
    const { lastUnloaded, currentOverrideTask } = this.state;
    let pickupWaypoints = [];

    if (taskAttrs.batchData) {
      if (taskAttrs.codeRequired && taskAttrs.batchData.type === BatchTypes.manyToOne && !arrival) {
        const displayTask = currentOverrideTask || lastUnloaded;
        const currTask = tasks.find((t) => t.uuid === displayTask);
        if (currTask) pickupWaypoints = [currTask.task_level_args.start_goal.value];
      }
      else {
        pickupWaypoints = taskAttrs.batchData.pickups;
      }
    }
    else {
      pickupWaypoints = [taskAttrs.waypointA];
    }

    return pickupWaypoints.map((waypt) => r2h(waypt));
  };

  validateCode = async (code) => {
    this.setState({ code, codeInputError: '' });

    const inputComplete = Array.from(code.values()).every((v) => v !== null);

    if (inputComplete) {
      let codeStr = '';
      code.forEach((v, k) => {
        codeStr += v;
      });
      const { tasksToUnload, unloadIdx, currentOverrideStep, forgotPinCodeClicked } = this.state;
      const isAdmin = currentOverrideStep === 2;
      const response = await validatePinCode(codeStr, tasksToUnload[unloadIdx], isAdmin);
      if (Object.keys(response).length && response.status === 'SUCCESS') {
        if (isAdmin) {
          // If M:1 and multiple drawers can be unloaded, show override option screen
          if (
            this.props.taskAttrs.batchData &&
            this.props.taskAttrs.batchData.type === BatchTypes.manyToOne &&
            tasksToUnload.length > 1
          ) {
            this.setState({
              currentOverrideStep: 3,
            });
          }
          else {
            // If "forgot code" was tapped, skip steps 3 and 4 (phase 1)
            // and automatically select 'Open Drawers' option, and 'recipient forgot code' reason
            this.setState({
              currentOverrideStep: forgotPinCodeClicked ? 5 : 4,
              overrideOption: 'open',
              overrideReason: forgotPinCodeClicked ? 'forgot' : '',
            });
          }
        }
        else {
          this.setState({ lastUnloaded: tasksToUnload[unloadIdx], unloadIdx: 0 });
        }
      }
      else {
        const attempts = response.attempts < 4 ? 3 - response.attempts : 0;
        const inputError = isAdmin
          ? "That's not the right code. Try again."
          : `That's not the right code. ${attempts > 0 ? 'Try again - you' : 'You'} have ${
              ATTEMPT_NUMBERS[attempts]
            } more attempt${attempts === 1 ? '' : 's'}.`;
        this.setState({ codeInputError: inputError });
      }
    }
  };

  getCodeGivenTo = (arrival) => {
    const { taskAttrs, tasks } = this.props;
    if (!taskAttrs.codeRequired) return '';

    // if the task was cancelled immediately after loading, we may arrive with no 'givenTo' populated
    let codeGivenTo = taskAttrs.codeGivenTo ? `Code given to ${taskAttrs.codeGivenTo}` : `Code missing`;

    if (taskAttrs.batchData) {
      const { type } = taskAttrs.batchData;
      const { tasksToUnload, unloadIdx } = this.state;

      if (type === BatchTypes.manyToOne) {
        if (arrival) {
          let combined = '';

          tasksToUnload.forEach((task, index) => {
            const unloadTask = tasks.find((t) => t.uuid === task);
            combined += `${index > 0 ? (index === tasksToUnload.length - 1 ? ', and ' : ', ') : ''}${
              unloadTask.task_data.code_given_to || `EMPTY`
            }`;
          });
          codeGivenTo = `EMPTY` in combined ? `Code missing` : `Codes given to ${combined}`;
        }
        else {
          const taskId = tasksToUnload[unloadIdx];
          const task = tasks.find((t) => t.uuid === taskId);

          if (task) codeGivenTo = codeGivenTo ? `Code given to ${task.task_data.code_given_to}` : `Code missing`;
        }
      }
    }

    return codeGivenTo;
  };

  getPickupLocation = () => {
    const { taskAttrs, tasks } = this.props;
    const { tasksToUnload, unloadIdx } = this.state;

    if (taskAttrs.batchData?.type === 'M_1') {
      const taskId = tasksToUnload[unloadIdx];
      const task = tasks.find((t) => t.uuid === taskId);
      if (task) return r2h(task.task_level_args.start_goal.value);
    }
    else {
      return null;
    }
  };

  handleNextLocationClick = () => {
    const { tasksToUnload, unloadIdx } = this.state;
    let newIdx = unloadIdx + 1;
    if (newIdx > tasksToUnload.length - 1) newIdx = 0;
    this.setState({ unloadIdx: newIdx });
  };

  handleForgotCodeClick = () => {
    const { tasksToUnload, unloadIdx } = this.state;
    this.setState({ forgotPinCodeClicked: true });

    setAdminOverride(true, tasksToUnload[unloadIdx]);
  };

  handlePinCodeCancel = () => {
    const { tasksToUnload, unloadIdx } = this.state;

    setAdminOverride(false, tasksToUnload[unloadIdx]);
  };

  handlePinCodeContinue = async () => {
    const { taskAttrs, tasks } = this.props;
    const {
      currentOverrideStep,
      tasksToUnload,
      overrideOption,
      overrideReason,
      overrideRecipient,
      currentOverrideTask,
    } = this.state;

    let taskToOpen = currentOverrideTask;
    let tasksToOpen = tasksToUnload;

    if (taskAttrs.batchData && taskAttrs.batchData.type === BatchTypes.manyToOne) {
      const batchId = taskAttrs.batchData.id;
      const batchTasks = tasks.filter((t) => t.task_data.batch?.id === batchId).map((t) => t.uuid);
      tasksToOpen = batchTasks;
    }

    if (currentOverrideStep === 5) {
      const response = await adminOpenDrawers(overrideOption === 'open-all' ? tasksToOpen : [taskToOpen]);

      const data = {
        override_option: overrideOption,
        override_reason: overrideReason,
        override_recipient: overrideRecipient,
      };

      if (overrideOption === 'open-all') {
        for (let i = 0; i < tasksToOpen.length; i++) {
          updateTaskData(tasksToOpen[i], data); //await
        }
      }
      else {
        updateTaskData(taskToOpen, data); //await
      }

      this.setState({
        lastUnloaded: taskToOpen,
        overrideOption: '',
        overrideReason: '',
        overrideRecipient: '',
        currentOverrideTask: '',
      });

      if (!response) {
        // Show error screen?
      }
    }
    else {
      this.setState({ currentOverrideStep: currentOverrideStep + 1 });
    }
  };

  render() {
    let ccMode = this.state.ccTaskInfo?.mode;
    if (this.state.doBatchAssist || (ccMode && ccMode != 'delivery' && ccMode != 'unload')) {
      //don't show nurse interactivity; the next step is that RFM remote-marks a drawer to get past this state
      return <ThinkingScreen />;
    }

    let deliveryNote = this.props.taskAttrs.note;
    if (deliveryNote) deliveryNote = deliveryNote.trim();
    if (this.props.autoPrioConfig?.pin_code_phase1 && this.props.taskAttrs.codeRequired) {
      let givenTo;

      if (this.state.currentOverrideTask || this.state.lastUnloaded) {
        const unloadingTask = this.state.currentOverrideTask || this.state.lastUnloaded;
        const task = this.props.tasks.find((t) => t.uuid === unloadingTask);
        if (task) givenTo = task.task_data.code_given_to;
      }
      else {
        givenTo = this.props.taskAttrs.codeGivenTo;
      }
      if (deliveryNote && !deliveryNote.endsWith('.')) deliveryNote += '.';
      // if the task was cancelled immediately after loading, we may arrive with no 'givenTo' populated
      deliveryNote += givenTo ? ` Code given to ${givenTo}` : ` Code missing`;
    }

    if (this.state.showForgotPinCode && this.state.locktubes) {
      return (
        <ForgotPinCodeScreen
          tapToReload={() => {}}
          code={this.state.code}
          setCode={this.validateCode}
          inputError={this.state.codeInputError}
          setInputError={(error) => this.setState({ codeInputError: error })}
          forgotPinCodeClicked={this.state.forgotPinCodeClicked}
          handleCancel={this.handlePinCodeCancel}
          handleContinue={this.handlePinCodeContinue}
          currentStep={this.state.currentOverrideStep}
          setCurrentStep={(step) => this.setState({ currentOverrideStep: step })}
          selectedOption={this.state.overrideOption}
          setSelectedOption={(option) => this.setState({ overrideOption: option })}
          selectedReason={this.state.overrideReason}
          setSelectedReason={(reason) => this.setState({ overrideReason: reason })}
          recipient={this.state.overrideRecipient}
          setRecipient={(recipient) => this.setState({ overrideRecipient: recipient })}
          tasksToUnload={this.state.tasksToUnload}
          pickupLocation={this.getPickupLocation()}
        />
      );
    }

    if (this.state.showPinCodeEntry && this.state.locktubes) {
      return (
        <PinCodeEntryScreen
          clickForgot={this.handleForgotCodeClick}
          tapToReload={() => {}}
          code={this.state.code}
          setCode={this.validateCode}
          givenTo={this.getCodeGivenTo()}
          inputError={this.state.codeInputError}
          setInputError={(error) => this.setState({ codeInputError: error })}
          pickupLocation={this.getPickupLocation()}
          clickNext={this.handleNextLocationClick}
          tasksToUnload={this.state.tasksToUnload}
        />
      );
    }

    if (this.state.arrivalMode < 2 || this.state.showArrivalScreen) {

      let ccMode = this.state.ccTaskInfo?.mode;

      let mainText = GENERAL_DROPOFF_TEXT;
      if(ccMode && ccMode == 'delivery')
        mainText = `Shift delivery`;
      else if(ccMode && ccMode == 'unload')
        mainText = `Full unload at the end of a delivery shift`;
      else if(!this.props.taskAttrs.failedToPullTask)
        mainText = composeArrivalUnloadText(this.getPickupDisplayNames(), this.props.taskAttrs.isScheduled, this.props.taskAttrs.restricted, this.props.taskAttrs.codeRequired );

      return (
        <ArrivalScreen
          mainText={mainText}
          noteText={this.props.taskAttrs.failedToPullTask ? LOST_CONNECTION_TEXT : this.props.taskAttrs.note}
          requestedBy={r2h(this.props.taskAttrs.requestedBy)}
          showPleaseWait={this.state.arrivalMode !== 1}
          showScanPrompt={this.state.arrivalMode === 1}
          textDisplayMode={this.props.taskAttrs.failedToPullTask}
          scanResult={this.state.scanResult}
          lastScanTimestamp={this.state.lastScanTimestamp}
          isRestricted={this.props.taskAttrs.restricted}
          givenToText={this.getCodeGivenTo(true)}
        />
      );
    }

    let pleaseUnloadTextSize = 36;
    let pleaseUnloadTextStyle = {
      width: '100%',
      fontWeight: 700,
      fontSize: pleaseUnloadTextSize,
      justifyContent: 'center',
      textAlign: 'center',
      minHeight: pleaseUnloadTextSize * 2,
      marginBottom: 40,
    };
    let leavingTextStyle = { fontWeight: 600, fontSize: 36, justifyContent: 'center', textAlign: 'center' };
    let noteTextStyle = { fontWeight: 400, fontSize: 20 };

    const progressPercent = 1 - (this.state.remainingCountdownTicks || 0) / (this.startingCountdownTicks || 1);

    let drawerStr = this.state.numDrawersUnlocked < 2 ? 'drawer' : this.state.numDrawersUnlocked + ' drawers';

    return (
      <div style={{ flex: 1, backgroundColor: '#fff' }}>
        {this.state.isLoading && <Loader loading={true} showSuccess={this.state.showSuccess}></Loader>}

        <Header showBackBt={false} />

        {this.state.anyTubeUnlocked && (
          <div
            style={{
              flexDirection: 'column',
              flex: 0.9,
              alignItems: 'center',
              marginLeft: 50,
              marginRight: 50,
              marginTop: 50,
            }}
          >
            <div style={pleaseUnloadTextStyle}>
              {this.props.taskAttrs.failedToPullTask ? (
                <span>
                  Unload your items from Moxi
                  {`, then close the ${drawerStr}.`}
                </span>
              ) : (
                <span>
                  Unload your items from{' '}
                  <span style={{ color: moxiVerdigris }}>{joinCommaSeparatedNames(this.getPickupDisplayNames())}</span>
                  {`, then close the ${drawerStr}.`}
                </span>
              )}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                marginLeft: 50,
                marginRight: 50,
              }}
            >
              {!!this.state.locktubes && (
                <StoragePlusLoadingView locktubes={this.state.locktubes} showOpenClosed={true} />
              )}
              {!!deliveryNote && (
                <div style={{ textAlign: 'left' }}>
                  <div style={noteTextStyle}>
                    <span style={{ color: '#757575' }}>Notes:</span>
                    <br />
                    <span style={{ color: 'black' }}>{deliveryNote}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {!this.state.anyTubeUnlocked && !!this.state.remainingCountdownTicks && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '80%' }}>
            <div style={{ flex: 1 }} />
            <div style={leavingTextStyle}>{'Leaving for the next task in...'}</div>

            <div
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 70, width: '50%' }}
            >
              <div style={leavingTextStyle}>{Math.floor(this.state.remainingCountdownTicks / 1000) + ' seconds'}</div>
              <div
                style={{ height: 20, width: '100%', borderColor: 'black', borderWidth: 1, backgroundColor: '#2D9CA4' }}
              >
                <div
                  style={{ width: Math.floor(100 * progressPercent) + '%', backgroundColor: 'white', height: 20 }}
                ></div>
              </div>
            </div>

            <DRButton
              action={() => this.cancelRollout()}
              disabled={this.state.remainingCountdownTicks < 1000}
              phrase={'UNLOAD AGAIN'}
              fontColor={'white'}
              fillColor={confirmColor}
              borderColor={confirmBorderColor}
            />
            <div style={{ flex: 1 }} />
          </div>
        )}

        {!this.state.anyTubeUnlocked && !this.state.remainingCountdownTicks && (
          <div
            style={{
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              width: '100%',
              height: '90%',
              fontWeight: 600,
              fontSize: 36,
            }}
          >
            One moment...
          </div>
        )}
      </div>
    );
  }
}

UnloadScreen.navigationOptions = {
  header: null,
};

// Note: This is needed because publishing to expo runs minify, which changes the class names. In particular, classes
//       can end up with the same name which breaks the screen transition logic.
UnloadScreen.viewName = 'UnloadScreen';
